export const STATE_CITY_DATA = {
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Andhra Pradesh": [
    "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool",
    "Rajahmundry", "Tirupati", "Kakinada", "Kadapa", "Anantapur",
    "Eluru", "Vizianagaram", "Ongole", "Nandyal", "Machilipatnam"
  ],
  "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat", "Tawang", "Ziro"],
  "Assam": [
    "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon",
    "Tinsukia", "Tezpur", "Bongaigaon", "Karimganj", "Sivasagar"
  ],
  "Bihar": [
    "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia",
    "Darbhanga", "Bihar Sharif", "Arrah", "Begusarai", "Katihar",
    "Munger", "Chhapra", "Danapur", "Saharsa", "Sasaram", "Hajipur"
  ],
  "Chandigarh": ["Chandigarh"],
  "Chhattisgarh": [
    "Raipur", "Bhilai", "Bilaspur", "Korba", "Rajnandgaon",
    "Durg", "Jagdalpur", "Ambikapur", "Raigarh"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": ["Daman", "Diu", "Silvassa"],
  "Delhi": [
    "New Delhi", "Delhi", "North Delhi", "South Delhi", "West Delhi",
    "East Delhi", "Central Delhi", "Dwarka", "Rohini", "Connaught Place",
    "Saket", "Vasant Kunj", "Karol Bagh", "Janakpuri", "Laxmi Nagar"
  ],
  "Goa": ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda", "Calangute"],
  "Gujarat": [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar",
    "Jamnagar", "Gandhinagar", "Junagadh", "Anand", "Navsari",
    "Morbi", "Nadiad", "Surendranagar", "Bharuch", "Porbandar", "Vapi"
  ],
  "Haryana": [
    "Gurgaon", "Faridabad", "Panipat", "Ambala", "Yamunanagar",
    "Rohtak", "Hisar", "Karnal", "Sonipat", "Panchkula",
    "Sirsa", "Bhiwani", "Bahadurgarh", "Jind", "Thanesar", "Rewari"
  ],
  "Himachal Pradesh": [
    "Shimla", "Dharamshala", "Solan", "Mandi", "Kullu",
    "Manali", "Baddi", "Bilaspur", "Hamirpur", "Una", "Nahan"
  ],
  "Jammu and Kashmir": [
    "Srinagar", "Jammu", "Anantnag", "Baramulla", "Udhampur",
    "Kathua", "Sopore", "Rajouri"
  ],
  "Jharkhand": [
    "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar",
    "Hazaribagh", "Giridih", "Ramgarh", "Medininagar"
  ],
  "Karnataka": [
    "Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum",
    "Gulbarga", "Davanagere", "Bellary", "Shimoga", "Tumkur",
    "Bijapur", "Raichur", "Bidar", "Hospet", "Udupi"
  ],
  "Kerala": [
    "Thiruvananthapuram", "Kochi", "Kozhikode", "Kollam", "Thrissur",
    "Kannur", "Alappuzha", "Palakkad", "Kottayam", "Malappuram", "Kasaragod"
  ],
  "Ladakh": ["Leh", "Kargil"],
  "Lakshadweep": ["Kavaratti", "Agatti"],
  "Madhya Pradesh": [
    "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain",
    "Sagar", "Dewas", "Satna", "Ratlam", "Rewa",
    "Murwara (Katni)", "Singrauli", "Burhanpur", "Khandwa", "Morena"
  ],
  "Maharashtra": [
    "Mumbai", "Pune", "Nagpur", "Thane", "Nashik",
    "Aurangabad", "Solapur", "Navi Mumbai", "Kolhapur", "Amravati",
    "Nanded", "Sangli", "Jalgaon", "Akola", "Latur", "Dhule", "Ahmednagar"
  ],
  "Manipur": ["Imphal", "Churachandpur", "Thoubal"],
  "Meghalaya": ["Shillong", "Tura", "Jowai"],
  "Mizoram": ["Aizawl", "Lunglei", "Champhai"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung"],
  "Odisha": [
    "Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur",
    "Puri", "Balasore", "Bhadrak", "Baripada", "Jharsuguda"
  ],
  "Puducherry": ["Puducherry", "Karaikal", "Ozhukarai"],
  "Punjab": [
    "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda",
    "Mohali", "Hoshiarpur", "Pathankot", "Moga", "Batala",
    "Abohar", "Malerkotla", "Khanna", "Phagwara"
  ],
  "Rajasthan": [
    "Jaipur", "Jodhpur", "Kota", "Bikaner", "Ajmer",
    "Udaipur", "Bhilwara", "Alwar", "Bharatpur", "Sikar",
    "Pali", "Sri Ganganagar", "Beawar", "Barmer"
  ],
  "Sikkim": ["Gangtok", "Namchi", "Gyalshing"],
  "Tamil Nadu": [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem",
    "Tirunelveli", "Tiruppur", "Vellore", "Erode", "Thoothukudi",
    "Dindigul", "Thanjavur", "Ranipet", "Sivakasi", "Karur", "Nagercoil"
  ],
  "Telangana": [
    "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam",
    "Ramagundam", "Secunderabad", "Mahbubnagar", "Nalgonda", "Adilabad"
  ],
  "Tripura": ["Agartala", "Udaipur", "Dharmanagar"],
  "Uttar Pradesh": [
    "Lucknow", "Kanpur", "Noida", "Greater Noida", "Ghaziabad",
    "Agra", "Varanasi", "Meerut", "Prayagraj", "Bareilly",
    "Aligarh", "Moradabad", "Gorakhpur", "Saharanpur", "Firozabad",
    "Jhansi", "Muzaffarnagar", "Mathura", "Ayodhya"
  ],
  "Uttarakhand": [
    "Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur",
    "Rishikesh", "Kashipur", "Nainital", "Pithoragarh"
  ],
  "West Bengal": [
    "Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri",
    "Bardhaman", "Malda", "Kharagpur", "Habra", "Shantipur", "Berhampore"
  ]
};

// Ensure alphabetical order for states and each city's list
Object.keys(STATE_CITY_DATA).forEach(state => {
  STATE_CITY_DATA[state] = STATE_CITY_DATA[state].slice().sort((a, b) => a.localeCompare(b));
});

export const STATES_LIST = Object.keys(STATE_CITY_DATA).sort((a, b) => a.localeCompare(b));

// Fallback all major cities list if state not selected yet, also sorted
export const ALL_CITIES_LIST = Array.from(
  new Set(Object.values(STATE_CITY_DATA).flat())
).sort((a, b) => a.localeCompare(b));
